/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Franchise_Create_Owner_EmailInputs */

const cs_franchise_create_owner_email = /** @type {(inputs: Franchise_Create_Owner_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail majitele`)
};

const en_franchise_create_owner_email = /** @type {(inputs: Franchise_Create_Owner_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Owner email`)
};

/**
* | output |
* | --- |
* | "Owner email" |
*
* @param {Franchise_Create_Owner_EmailInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const franchise_create_owner_email = /** @type {((inputs?: Franchise_Create_Owner_EmailInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Franchise_Create_Owner_EmailInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_franchise_create_owner_email(inputs)
	return cs_franchise_create_owner_email(inputs)
});